import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BackButton, TableData } from 'components';
import { errorAlert } from 'helpers/alerts';
import moment from 'moment';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getExceptionHistoryService } from 'services/roteo/exceptionService';
import { setCurrentExceptionHistory } from 'redux/slices/route/exceptionSlice';
import { ListAlt } from '@mui/icons-material';

const ExceptionHistoryScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentException } = useSelector(store => store.exceptions);
  const [historial, setHistorial] = useState([])
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    setLoading(true);
    getExceptionHistoryService(currentException.id).then((response) => {
      setHistorial(response)
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerTxns = async (row) => {
    dispatch(setCurrentExceptionHistory(row));
    navigate("transacciones")
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton
            name={"Regresar"}
            click={() => navigate(-1)}
          />
        </div>
        <div className="container-title">
          <div className="title">Historal de Excepción</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={historial}
        loading={loading}
        dataTitle={[
          "Estatus",
          "Fecha de Inicio",
          "Fecha de Fin",
          "Transacciónes",
        ]}
        formatter={({
          startDate,
          endDate,
          operations,
          state,
        }) => [
            state ? 'Activo' : 'Finalizado',
            moment(startDate).format('DD/MM/YYYY HH:mm:ss '),
            endDate ? moment(endDate).format('DD/MM/YYYY HH:mm:ss ') : '-',
            operations.length,
          ]}
        actions={[
          {
            label: "Transacciones",
            icon: <ListAlt />,
            onClick: (data) => handlerTxns(data)
          },
        ]}
      />
    </>

  )
}

export default ExceptionHistoryScreen